module.exports = __webpack_public_path__ + "static/media/RoroBannerAPP-01.3bd7ad6e.png";